type Locale = {
  code: string;
  locale: string;
};

export const localeCodes: Readonly<Locale[]> = [
  { code: "bg-BG", locale: "Bulgarian" },
  { code: "zh-MO", locale: "Chinese (Macao)" },
  { code: "zh-CN", locale: "Chinese (Simplified)" },
  { code: "zh-HK", locale: "Chinese (Traditional - HK)" },
  { code: "zh-TW", locale: "Chinese (Traditional - Taiwan)" },
  { code: "hr-HR", locale: "Croatian" },
  { code: "cs-CZ", locale: "Czech" },
  { code: "da-DK", locale: "Danish" },
  { code: "nl-NL", locale: "Dutch" },
  { code: "en-AU", locale: "English (Australia)" },
  { code: "en-CA", locale: "English (Canada)" },
  { code: "en-DO", locale: "English (Dominican Republic)" },
  { code: "en-IE", locale: "English (Europe)" },
  { code: "en-GB", locale: "English (GB)" },
  { code: "en-IN", locale: "English (India)" },
  { code: "en-US", locale: "English (US)" },
  { code: "et-EE", locale: "Estonian" },
  { code: "fi-FI", locale: "Finnish" },
  { code: "fr-FR", locale: "French" },
  { code: "fr-CA", locale: "French (Canada)" },
  { code: "fr-CH", locale: "French (Switzerland)" },
  { code: "de-DE", locale: "German" },
  { code: "de-AT", locale: "German (Austria)" },
  { code: "de-CH", locale: "German (Switzerland)" },
  { code: "el-GR", locale: "Greek" },
  { code: "hu-HU", locale: "Hungarian" },
  { code: "id-ID", locale: "Indonesian - Bahasa Indonesia" },
  { code: "it-IT", locale: "Italian" },
  { code: "ja-JP", locale: "Japanese" },
  { code: "kk-KZ", locale: "Kazakh (KZ)" },
  { code: "ko-KR", locale: "Korean" },
  { code: "lv-LV", locale: "Latvian" },
  { code: "lt-LT", locale: "Lithuanian" },
  { code: "ms-MY", locale: "Malay - Bahasa Malaysia" },
  { code: "mn-MN", locale: "Mongolian" },
  { code: "nb-NO", locale: "Norwegian Bokmål" },
  { code: "pl-PL", locale: "Polish" },
  { code: "pt-PT", locale: "Portuguese" },
  { code: "pt-BR", locale: "Portuguese (Brazil)" },
  { code: "ro-RO", locale: "Romanian" },
  { code: "ru-KZ", locale: "Russian (Kazakhstan)" },
  { code: "ru-UA", locale: "Russian (Ukraine)" },
  { code: "sk-SK", locale: "Slovak" },
  { code: "sl-SI", locale: "Slovene" },
  { code: "es-ES", locale: "Spanish" },
  { code: "es-DO", locale: "Spanish (Dominican Republic)" },
  { code: "es-MX", locale: "Spanish (LATAM)" },
  { code: "es-US", locale: "Spanish (US)" },
  { code: "sv-SE", locale: "Swedish" },
  { code: "th-TH", locale: "Thai" },
  { code: "tr-TR", locale: "Turkish" },
  { code: "uk-UA", locale: "Ukrainian" },
  { code: "uz-UZ", locale: "Uzbek" },
  { code: "vi-VN", locale: "Vietnamese" },
  { code: "bi-HT", locale: "Xxxx Xxxx" },
  { code: "ln-HT", locale: "Xxxx Xxxx (long)" },
];

/** Array of all language codes supported */
export const supportedLanguageCodes = localeCodes.map((locale) => locale.code);
